import { TutorialType } from './tutorial-type';

/** Supported notification types. Used to determine parsing logic */
export enum NotificationType {

  /** Our internal types, body will be nested to incluee actual type */
  INTERNAL = 'internal',

  IAM = 'iam',
  Boka = 'boka',
  SalesIndex = 'weekly-sales',
  HappyCustomer = 'happy-customer',
  Tutorial = 'tutorial',
  Stay = 'stay',
  MIA = 'mia-availability',
}

/** All other notification types will be auto subscribed to */
export const DO_NOT_AUTO_SUBSCRIBE = [
  NotificationType.HappyCustomer,
  NotificationType.SalesIndex,
];

/** IAM - can be both incoming and outgoing */
export interface IAMNotification {
  accessRequestId: string;
  accessName: string;
  accessDescription?: string;

  requester: string;
  recipient: string;
  approver: string;

  /** When requested */
  link?: string;
  validFrom?: string;
  validUntil?: string;
  orderDate?: string;

  /** When approved */
  decision?: 'approved' | 'denied';
  reason?: string;
}

/** Boka */
export interface BokaNotification {
  appointmentId: number;
  assignedCoworker: string;
  appointmentStatus: string;
  appointmentLink: string;
  countryCode: string;
  customerId: string;
  languageCode: string;
  locationName: string;
  locationType: 'STORE';
  messageId: string;
  messageTime: string;
  orderNumber: string;
  orderNumberSrc: string;
  region: 'EU' | 'NA' | 'AP' | 'CN' | 'RU';
  timeWindow: {
    startTime: number;
    endTime: number;
  };
  topicVerb: 'created' | 'changed' | 'order_received' | 'order_received_waiting_for_payment' | 'started' | 'completed' | 'cancelled' | 'cancelled_no_show' | 'planned';
  comments: {
    comment: string;
    createdAt: string;
  }[];
}

/** Weekly sales, happy customer score, etc */
export interface SalesNotification {
  oid: string;
  unitName: string;
  unitType: number;
  currentValue: number;
  goal: number;
}

/** Notification about not used features (tutorials) */
export interface TutorialNotification {
  oid: string;

  /** Rest is resolved client side from the tutorial service. */
  tutorial: TutorialType;
}

/** Notifications from stay */
export interface StayNotification {
  notification_upn: string;
  notification_title: string;
  notification_text: string;
  notification_buttonlink: string;
}

export interface MIANotification {
  payload: {
    id: 609;
    coworkerEmail: string;
    creatorEmail: string;
    seen: boolean;
    createdOn: string;
    updatedOn: string;
    availabilitySnapshot: {
      id: number;
      coworkerId: number;
      workPreference: number;
      startDate: string;
      endDate: string;
      startTime: string;
      endTime: string;
      weekdays: any[];
      recurrence: 0 | 1;
      status: 1 | 2;
      createdOn: string;
    };
  };
}
